module.exports = "<div class=driver-image [ngStyle]=\"{'background-image' : 'url('+driverImage+')'}\"></div> ";